<script>
    export let href;
    export let text;
</script>

<style>
    a {
        text-decoration: underline;
        color: #00afc3;
    }
</style>

<a href="{href}" target="_blank">{text}</a>


